import HttpRequest from './HttpRequest';

export default class PartnerService extends HttpRequest {
  static endpoint = 'partners';

  static async getAll() {
    this.endpoint = 'partners';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'partners';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'partners';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'partners';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'partners';
    const response = await this.put(id, data);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'partners/create-avatar';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'partners/delete-avatar';
    const response = await this.delete(data);
    return response;
  }
}
